<template>
	<div class="product">
		<el-card shadow="hover">
			<div slot="header" class="clearfix">
				<span>产品分类列表</span>
				<el-button style="float: right; padding: 3px 0" type="text" @click="AddBtn()">新增产品分类
				</el-button>
			</div>
			<el-table :data="showDate()" style="width: 100%;margin-bottom: 20px;">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="name" label="分类名称">
				</el-table-column>
				<el-table-column prop="orderIndex" label="排序序号">
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间">
				</el-table-column>
				<el-table-column label="操作" width="200">
					<template slot-scope="scope">
						<el-button size="mini" style="margin-right: 10px;" icon="el-icon-edit" @click="edit(scope.row)">
							编辑</el-button>&nbsp;
						<el-popconfirm title="确定要删除吗" @confirm="del(scope.row.id)">
							<el-button size="mini" type="danger" icon="el-icon-delete" slot="reference">
								删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="tableData.length"
				class="pagination" @size-change="sizeChange" @current-change="currentChange">
			</el-pagination>
		</el-card>
		<el-dialog :title="dialogType=='Add'?'新增分类':'编辑分类'" :visible.sync="outerVisible" width='30%'>
			<el-form :model="dialogModels" :inline="true">
				<el-row>
					<el-col :span="24">
						<el-form-item label="分类名称">
							<el-input v-model="dialogModels.name"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="排序序号">
							<el-input-number v-model="dialogModels.orderIndex" :min="1" :max="100" label="描述文字">
							</el-input-number>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="outerVisible = false">取 消</el-button>
				<el-button type="primary" @click="save()">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				//table +分页
				tableData: [],
				page_size: 10,
				page_current: 1,
				//弹出框-编辑 添加				
				outerVisible: false,
				dialogModels: {
					id: '',
					name: '',
					orderIndex: 0
				},
				dialogType: 'Add'
				//其他操作

			}
		},
		created() {
			this.loadTableList()
		},
		methods: {
			showDate() {
				return this.tableData.slice((this.page_current - 1) * this.page_size, this.page_current * this.page_size)
			},
			sizeChange(e) {
				this.page_size = e
			},
			currentChange(e) {
				this.page_current = e
			},
			loadTableList() {
				this.$http.get('api/Product/GetProduct_Categorys').then(res => {
					this.tableData = res.data.data
				})
			},
			AddBtn() {
				this.outerVisible = true
				this.dialogType = 'Add'
				this.dialogModels = {
					orderIndex: Math.max.apply(Math, this.tableData.map(item => {
						return item.orderIndex
					})) + 1
				}
			},
			del(val) {
				this.$http.get('api/Product/DelProduct_Category/' + val).then(res => {
					if (res.data.code == '1') {
						this.$message({
							message: "删除成功",
							type: 'success'
						})
						this.loadTableList()
					}
				})
			},
			edit(val) {
				this.dialogModels = val
				this.outerVisible = true
				this.dialogType = 'Up'
			},
			async save() {
				if (this.dialogModels.name == '' || this.dialogModels.name == null) {
					this.$message({
						message: "产品名称不能为空",
						type: 'info'
					})
				} else {
					//保存 产品分类 信息
					this.$http.post('api/Product/EditProduct_Category', this.dialogModels).then(res => {
						if (res.data.code == '1') {
							this.$message({
								message: "产品记录保存成功",
								type: 'success'
							})
							this.outerVisible = false
							this.loadTableList()

						} else {
							this.$message({
								message: "产品记录保存失败",
								type: 'error'
							})
						}
					})
				}
			}
		}
	}
</script>

<style lang="scss">
	.product{
		.pagination {
			margin: 10px 0;
			text-align: center;
		}
	}
</style>

